import { DevoteeDetail, PoojaBookedJson } from './../../../model/pooja/pooj-booking-response';
import { Injectable, Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@otas/modal/modal';
import { Observable } from 'rxjs';
import { InvoiceDetails } from '@otas/model/payment/transaction';
import { ConfirmModalService } from '@otas/shared/confirm-modal/confirm-modal.component';
import { NgbModalRef } from '@otas/modal/modal-ref';
import { DateService } from '../../../services/date.service';
import moment from 'moment';
import { forkJoin } from 'rxjs';

@Injectable()
export class AddPaymentModalService {
  modalRef: NgbModalRef;
  constructor(public modalService: NgbModal, private http: HttpClient, private confirmModalService: ConfirmModalService) { }
  addPaymentModalOpen(component: Component, flag, data: InvoiceDetails) {
    console.log(data)
    const modalRef = this.modalService.open(component);
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.flag = flag;
    return modalRef;
  }
  addPaymentModalOpenMultiple(component: Component, flag, array,multiDueAmount) {
    const modalRef = this.modalService.open(component);
     modalRef.componentInstance.array = array;
     modalRef.componentInstance.multiDueAmount = multiDueAmount;
    return modalRef;
  }
  addPaymentSubmit(obj): Observable<any> {
    return this.http.post<any>(`pooja/add/payment`,obj);
  }
  
  getAllbankList(): Observable<any> {
    return this.http.get<any>(`account-head/bank`);
  }
  addPayment(object): Observable<any> {
    return this.http.post<any>(`payment/expense/billing`, object);
  }
  addPaymentForPoojaEnquiry(object): Observable<any> {
    return this.http.post<any>(`payment/pooja/booking`, object);
  }
  getAllAccount(): Observable<any> {
    return this.http.get<any>(`account-head/payment`);
  }

  getPoojaEnquiryByInvoiceId(invoiceId: number): Observable<any> {
    return this.http.get<any>(`pooja/enquiry/${invoiceId}`);
  }

  getPoojaEnquiryByInvoiceIds(invArray: any[]): Observable<any> {
    const uriArray = [];
    invArray.forEach(inv=>{
      uriArray.push(this.http.get<any>(`pooja/enquiry/${inv}`));
    });
    return forkJoin(uriArray);
  }


  setInvoiceForPrint(invoice, poojaInvoice, papertType): PoojaBookedJson {
    let total = 0;
    invoice.forEach(e => {
      total = total + e.amount;
    });
    poojaInvoice.billDate = DateService.dateTimeFormatString(invoice[0].transactionDate);
    poojaInvoice.bookedOn = (!!invoice[0].poojaDateCount && +invoice[0].poojaDateCount < 17) ? invoice[0].poojaDate : invoice[0].poojaOn;
    poojaInvoice.invoiceId = invoice[0].invoiceId;
    poojaInvoice.poojaTime = (!!invoice[0].time) ? invoice[0].time : '';
    poojaInvoice.invoiceNumber = invoice[0].prefix + '' + invoice[0].invoiceNo;
    poojaInvoice.paymentMode = invoice[0].paymentMode;
    poojaInvoice.chequeNo = invoice[0].chequeNo;
    poojaInvoice.invoiceTotal = total;
    poojaInvoice.paidAmount = invoice[0].paidAmount;
    if (invoice[0].property === 'SALE' || invoice[0].property === 'SAMARPANAM' || invoice[0].property === 'NADAVARAVU') {
      poojaInvoice.poojaName = invoice[0].devoteeName + (invoice[0]?.star ? ` ( ${invoice[0]?.star} )` : '');
    } else {
      poojaInvoice.poojaName = (invoice[0].property === 'MULTI_POOJA_INVOICE') ? '' : invoice[0].poojaName + (!!invoice[0].separateInvoiceNo ? '(' + invoice[0].separateInvoiceNo + ')' : '');
    }
    poojaInvoice.note = invoice[0].note;
    poojaInvoice.property = invoice[0].property;
    poojaInvoice.devoteeDetailList = [];
    poojaInvoice.deityName = (invoice[0].property === 'MULTI_POOJA_INVOICE') ? '' : invoice[0].deityName;

    invoice.forEach(element => {
      const devotee = new DevoteeDetail();
      if (invoice[0].property === 'SALE' || invoice[0].property === 'SAMARPANAM' || invoice[0].property === 'NADAVARAVU') {
        devotee.devoteeName = element.poojaName;
        devotee.devoteeAddress = '';
        devotee.devoteePhone = '';
        devotee.devoteeStar = '';
      } else {
        devotee.devoteeName = element.devoteeName;
        devotee.poojaName = (invoice[0].property === 'MULTI_POOJA_INVOICE') ? element.poojaName + (!!invoice[0].separateInvoiceNo ? '(' + invoice[0].separateInvoiceNo + ')' : '') : '';
        devotee.deityName = (invoice[0].property === 'MULTI_POOJA_INVOICE') ? '(' + element.deityName + ')' : '';
        devotee.devoteeAddress = element.devoteeAddress;
        devotee.devoteePhone = element.devoteePhone;
        devotee.devoteeStar = element.star;
        devotee.age = (!!element.dob) ? this.ageCalculation(element.dob) + '' : '';
      }
      devotee.amount = element.amount;
      devotee.quantity = element.quantity;
      devotee.rate = element.rate;
      devotee.unit = element.unit;
      poojaInvoice.devoteeDetailList.push(devotee);

    });

    poojaInvoice.templeDistrict = invoice[0].templeDistrict;
    poojaInvoice.voucherNo = invoice[0].voucherNo;
    if (poojaInvoice.property === 'MARRIAGE') {
      poojaInvoice.printType = (papertType === 'marriagecertificate') ? 'marriagecertificate' : 'marriage';
    }
    if (poojaInvoice.property === 'SPECIAL_DONATION') {
      poojaInvoice.printType = 'donation';
    }
    return  poojaInvoice;
  }
  public ageCalculation(dob: any): number {
    return moment().diff(dob, 'years');
  }
}
